import styled from 'styled-components'
import Icon from './Icon'

const DragIcon = styled(Icon).attrs({
  name: 'icon-dragdrop',
  size: 'big',
})`
  &&& {
    color: ${props => props.color || '#bdcbd0'};
    cursor: move;
    margin-right: 0;
    left: -6px;
  }
`
export default DragIcon
